import { booleanAttribute, Directive, input } from '@angular/core';
import { BaseCVAComponent } from '../base-cva/base-cva.component';

@Directive({})
export class PrimeNgControlComponent<T> extends BaseCVAComponent<T> {
  public readonly label = input('');
  public readonly placeholder = input('');
  public readonly id = input('');
  public readonly isRequired = input(false, { transform: booleanAttribute });
  public readonly fullWidth = input(true);
  public readonly iconName = input('');
}
